import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledDescriptionText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
`;

export const StyledCardHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  & {
    height: 2.4rem;
    width: 2.4rem;
    color: ${({ theme }) => theme.colors.error.main};
  }
`;
export const StyledHeaderTitle = styled.h2`
  font-size: 2.4rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 0rem;
`;
